import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { FirestoreService } from './firestore.service';

export type RemoteConfigType = 'maintenance-config';

interface BaseRemoteConfig {
  createdAt: Date;
  id: string;
  updatedAt: Date;
}

interface MaintenanceRemoteConfig extends BaseRemoteConfig {
  type: 'maintenance-config';
  value: {
    enabled: boolean;
  };
}

export type RemoteConfig = MaintenanceRemoteConfig;

const collectionPath = 'remoteConfigs';

@Injectable({
  providedIn: 'root',
})
export class RemoteConfigService {
  constructor(
    private firestoreService: FirestoreService,
  ) {}

  get(type: RemoteConfigType): Observable<RemoteConfig | null> {
    return this.firestoreService.doc<RemoteConfig>(`${collectionPath}/${type}`);
  }
}
